import { useNavigate } from "react-router-dom";
import { Button, Modal } from "antd";
import { useHospitalMappingStore } from "@stores/useHospitalMappingStore";
import { useConfigStore } from "@stores/useConfigStore";
import { HOSPITAL_LIST_AND_CM_USER_ACCESS_LIST, HOSPITAL_LIST_AND_CM_USER_OPENED_FROM, routeMap } from "@utils/constants";
import HospitalMapping from "../hospitalMapping";
import "./CmContactMatrixModalReadMode.scss";

const CmContactMatrixModalReadMode: React.FC = () => {
  const setShowMemberDetailsModal = useHospitalMappingStore((state) => state.setShowMemberDetailsModal);
  const showMemberDetailsModal = useHospitalMappingStore((state) => state.showMemberDetailsModal);
  const setIsBackButtonDisplay = useHospitalMappingStore((state) => state.setIsBackButtonDisplay);
  const setHospitalMappingEditModeOpenedFrom = useHospitalMappingStore((state) => state.setHospitalMappingEditModeOpenedFrom);
  const config = useConfigStore((state) => state.config);
  const navigate = useNavigate();

  return (
    <Modal
      width={"70%"}
      visible={showMemberDetailsModal}
      onCancel={() => {
        setShowMemberDetailsModal(false);
        setHospitalMappingEditModeOpenedFrom(HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.None);
      }}
      cancelButtonProps={{ hidden: true }}
      okButtonProps={{ hidden: true }}
      className={"adt-container__hospitalList-modal"}
    >
      <HospitalMapping currentMode="read" />
      <div className="cm-mapping-modal">
        {HOSPITAL_LIST_AND_CM_USER_ACCESS_LIST.includes(config?.role) ? (
          <Button
            type="primary"
            onClick={() => {
              setShowMemberDetailsModal(false);
              setIsBackButtonDisplay(true);
              navigate(routeMap.dashboard);
            }}
          >
            Edit Fields
          </Button>
        ) : null}
      </div>
    </Modal>
  );
};

export default CmContactMatrixModalReadMode;
